import { Avatar } from "components/avatar";
import { NoStyleA } from "components/button";
import TableComponent, { useTable } from "components/table";
import { format } from "date-fns";
import * as React from "react";
import { TInvoice } from "types/invoice";
import { dollarFormatter } from "utils";
import { Status } from "components/status";
import { useTranslation } from 'react-i18next';
import { enUS, es } from "date-fns/locale";
import { useAuthContext } from "contexts/auth";
import convertCVD  from "utils/convertCVD";

export default function InvoiceTable(props: {
  // since this component is now used for both company and single customers, any is used here, but this will need to be properly typed later
  data: (TInvoice[] | undefined) | any;
  handleClick?: (row: TInvoice) => void;
  pageIndex?: number;
  // pageCount?: number;
  table?: any;
  fixedColumnWidths?: boolean;
}) {
  const { t, i18n } = useTranslation();
  const tBase = "containers.invoiceTable.index";
  const tr = (key: string) => t(`${tBase}.${key}`);
  const locale = i18n.language === "es" ? es : enUS;
  const { cvd_type } = useAuthContext();

  // const table = useTable({
  //   url: true,
  //   // sor
  //   onSort: (sort) => {
  //
  //   },
  // });
  const columns = {
    id: {
      label: tr("Invoice #"),
      width: "6rem",
      minWidth: "5rem",
    },
    status: {
      label: tr("Status"),
      width: "7rem",
      minWidth: "6rem",
      cell: (row: TInvoice) => {
        const statusColor = convertCVD(row.status.color, cvd_type);
        return <Status color={statusColor}>{tr(row.status.label)}</Status>
      },
    },
    total: {
      label: tr("Total"),
      width: "6rem",
      minWidth: "5rem",
      style: {
        fontWeight: "bold",
      },
      cell: (row: TInvoice) => dollarFormatter(row.actual_total),
    },
    remaining: {
      label: tr("Due"),
      width: "6rem",
      minWidth: "5rem",
      cell: (row: TInvoice) => dollarFormatter(row.amount_due),
    },
    fk_request_id: {
      label: tr("Request #"),
      width: "6rem",
      minWidth: "5rem",
    },
    customer: {
      label: tr("Customer"),
      width: "14rem",
      minWidth: "10rem",
      maxWidth: "220px",
      style: { maxWidth: "220px" },
      cell: (row: TInvoice) => (
        <div className="min-w-0 overflow-hidden truncate">
          <Avatar showLabel size="xsmall">
            {row.customer.name}
          </Avatar>
        </div>
      ),
    },
    creation_date: {
      label: tr("Created"),
      width: "8rem",
      minWidth: "7rem",
      cell: (row: TInvoice) =>
        format(new Date(row.creation_date), "MMM dd, yyyy", {
          locale: locale,
        }),
    },
  };

  const handleClick = props.handleClick
    ? props.handleClick
    : (row: TInvoice) => {};

  return (
    <TableComponent
      columns={columns}
      data={props.data}
      type="a"
      to={(row: any) => {
        return `/invoices/${row.id}`;
      }}
      {...(props.table || {})}
      pageIndex={props.pageIndex}
      fixedColumnWidths={props.fixedColumnWidths}
    />
  );
}
